// Module
var code = "\r\n\r\n\r\n    <div  class=\"scrim scrim-loading-showx\"  id=\"scrim_loading\"       >\r\n\r\n         <div class=\"cont\">\r\n            <div></div>   \r\n         </div>\r\n         \r\n\r\n    </div>\r\n";
// Exports
export default code;